const APP_CONFIG = {
  version: "7.85.1",
  title: "Claire V7.85.1",
  version_client: "7.85.1",
};

export default APP_CONFIG;
